module.exports = __webpack_public_path__ + "static/media/yakuza-picture-3.d75f007b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Yakuza/yakuza-picture-3.jpg
// module id = 597
// module chunks = 0